import { User } from "@fairfleet/geotab";

export function findSignedInUser(users: User[] | undefined, username: string): User | null {
  const trimmed = username.trim();
  if (!trimmed) return null;
  if (!users || users.length === 0) return null;

  const target = trimmed.toLowerCase();
  const match = users.find(user => user.name?.trim().toLowerCase() === target);
  return match ?? null;
}
